// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  min-width: unset !important; }

.App {
  text-align: center; }

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 80px; }

.App-header {
  background-color: #222;
  height: 150px;
  padding: 20px;
  color: white; }

.App-title {
  font-size: 1.5em; }

.App-intro {
  font-size: large; }

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg); }
  to {
    transform: rotate(360deg); } }

.loading-page {
  position: absolute;
  width: 100%;
  left: 0;
  background-color: #4330ff; }

.hide {
  display: none; }

.clear {
  clear: both; }

.helper-text:hover {
  cursor: help; }

.note-buttons {
  float: right; }

.save-note-button {
  cursor: pointer;
  margin-top: 10px;
  width: 120px !important;
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  margin-bottom: 0.5em;
  border-width: 1px; }

.cancel-note-link, .cancel-pw-button {
  margin-right: 20px;
  cursor: pointer;
  color: #32c3b5 !important;
  text-decoration: underline !important; }

.error-color {
  color: #ff2e2e; }

.success-color {
  color: #38bb15; }

.margin-top-10 {
  margin-top: 10px; }

.react-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 195px;
  width: 300px;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;
  outline: none;
  padding-top: 20px; }
  .react-modal .modal-menu-title {
    color: #c0c0c0;
    width: 100%;
    text-align: center;
    font-size: 12px; }
  .react-modal .modal-menu-item {
    cursor: pointer;
    color: #4330ff;
    width: 100%;
    text-align: center;
    border: none;
    background-color: white; }
    .react-modal .modal-menu-item a {
      text-decoration: none;
      color: #2d7cbf !important; }
  .react-modal .modal-menu-divider {
    width: 100%;
    border-top: 1px solid #eaeaea;
    margin: 10px 0px 10px 0px;
    padding: 0px; }
  .react-modal.note-modal {
    height: 160px; }
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal, .react-modal.closing-details {
    padding: 45px; }
    .react-modal.error-modal .close-modal, .react-modal.info-modal .close-modal, .react-modal.evaluation-modal .close-modal, .react-modal.closing-details .close-modal {
      background-color: #fa504b;
      border-color: #fa504b;
      margin: auto;
      display: block; }
      .react-modal.error-modal .close-modal.btn-confirm, .react-modal.info-modal .close-modal.btn-confirm, .react-modal.evaluation-modal .close-modal.btn-confirm, .react-modal.closing-details .close-modal.btn-confirm {
        color: #ffffff;
        background-color: #606060;
        border-color: #606060; }
        .react-modal.error-modal .close-modal.btn-confirm:hover, .react-modal.info-modal .close-modal.btn-confirm:hover, .react-modal.evaluation-modal .close-modal.btn-confirm:hover, .react-modal.closing-details .close-modal.btn-confirm:hover {
          background-color: #c0c0c0;
          border-color: #c0c0c0; }
      .react-modal.error-modal .close-modal:hover, .react-modal.info-modal .close-modal:hover, .react-modal.evaluation-modal .close-modal:hover, .react-modal.closing-details .close-modal:hover {
        border-color: #fb736f;
        background-color: #fb736f; }
      .react-modal.error-modal .close-modal a, .react-modal.info-modal .close-modal a, .react-modal.evaluation-modal .close-modal a, .react-modal.closing-details .close-modal a {
        color: #ffffff; }
        .react-modal.error-modal .close-modal a:hover, .react-modal.info-modal .close-modal a:hover, .react-modal.evaluation-modal .close-modal a:hover, .react-modal.closing-details .close-modal a:hover {
          text-decoration: none; }
  .react-modal.evaluation-modal {
    width: 40%;
    height: fit-content;
    padding: 35px 20px 20px; }

.subheader {
  padding: 5px;
  padding-left: 10px;
  color: #404040;
  background: #dcdcdc;
  font-size: 20px;
  margin-top: 20px; }
  .subheader.centered {
    text-align: center; }

.dim {
  opacity: 0.6;
  cursor: default; }

.dim:hover {
  background: transparent !important; }

.center {
  text-align: center; }

.right {
  text-align: right; }

.blue-header {
  color: #4330ff; }

.bold {
  font-weight: bold; }

.red {
  color: #fa504b !important; }

.margin-bottom-10 {
  margin-bottom: 10px; }

button.standard {
  cursor: pointer;
  margin-top: 10px;
  width: 140px !important;
  border-radius: 5px;
  background-color: #4330ff;
  border: 1px solid #c0c0c0;
  color: #f2f2f2;
  margin-bottom: 0.5em; }

button.cancel {
  cursor: pointer;
  margin-top: 10px;
  width: 140px !important;
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  margin-bottom: 0.5em; }
  button.cancel:hover {
    cursor: pointer; }
  button.cancel:disabled {
    cursor: not-allowed; }

button.submit {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  margin: 0 20px 20px 20px;
  height: 40px;
  min-width: 120px;
  width: calc(50% - 2px);
  border-radius: 5px;
  background: #4330ff;
  color: white; }
  button.submit:hover {
    cursor: pointer; }
  button.submit:disabled {
    cursor: not-allowed; }

.no-results-message {
  text-align: center;
  font-weight: bold;
  margin-top: 30%; }

.lb-highlight {
  background-color: #ffebbb; }

.splash-screen {
  height: 100vh;
  width: 100vw;
  background-color: #4330ff;
  transition: visibility 1s, opacity 0.5s linear;
  position: absolute;
  visibility: visible;
  opacity: 1;
  top: 0; }
  .splash-screen.loaded {
    visibility: hidden;
    opacity: 0; }
  .splash-screen .splash-logo {
    margin: 100px 0px; }
    .splash-screen .splash-logo img {
      width: 50%;
      max-width: 950px;
      margin: auto;
      display: block; }
  .splash-screen .spinner-container {
    text-align: center;
    color: #fff;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    font-size: 3em; }
    .splash-screen .spinner-container .fa-spin {
      position: relative;
      top: 40%; }

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 585px) {
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
    width: 90%;
    padding: 35px; } }

/* Small devices (portrait tablets and large phones, 767px and under) */
/* No greater than 767px, no less than 586px */
@media only screen and (max-width: 767px) and (min-width: 586px) {
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
    width: 75%; } }

/* Large devices (laptops/desktops, 768px and up) */
@media only screen and (min-width: 768px) {
  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {
    max-width: 596px;
    width: 90%; } }
`, "",{"version":3,"sources":["webpack://./src/components/App/app.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B,EAAE;;AAE/B;EACE,kBAAkB,EAAE;;AAEtB;EACE,4CAA4C;EAC5C,YAAY,EAAE;;AAEhB;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,YAAY,EAAE;;AAEhB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,yBAAyB,EAAE;;AAE7B;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qCAAqC,EAAE;;AAEzC;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,iBAAiB,EAAE;EACnB;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe,EAAE;EACnB;IACE,eAAe;IACf,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,uBAAuB,EAAE;IACzB;MACE,qBAAqB;MACrB,yBAAyB,EAAE;EAC/B;IACE,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY,EAAE;EAChB;IACE,aAAa,EAAE;EACjB;IACE,aAAa,EAAE;IACf;MACE,yBAAyB;MACzB,qBAAqB;MACrB,YAAY;MACZ,cAAc,EAAE;MAChB;QACE,cAAc;QACd,yBAAyB;QACzB,qBAAqB,EAAE;QACvB;UACE,yBAAyB;UACzB,qBAAqB,EAAE;MAC3B;QACE,qBAAqB;QACrB,yBAAyB,EAAE;MAC7B;QACE,cAAc,EAAE;QAChB;UACE,qBAAqB,EAAE;EAC/B;IACE,UAAU;IACV,mBAAmB;IACnB,uBAAuB,EAAE;;AAE7B;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAE;EAClB;IACE,kBAAkB,EAAE;;AAExB;EACE,YAAY;EACZ,eAAe,EAAE;;AAEnB;EACE,kCAAkC,EAAE;;AAEtC;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB,EAAE;;AAEvB;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,oBAAoB,EAAE;;AAExB;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,oBAAoB,EAAE;EACtB;IACE,eAAe,EAAE;EACnB;IACE,mBAAmB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY,EAAE;EACd;IACE,eAAe,EAAE;EACnB;IACE,mBAAmB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;;AAE7B;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EAGzB,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,MAAM,EAAE;EACR;IACE,kBAAkB;IAClB,UAAU,EAAE;EACd;IACE,iBAAiB,EAAE;IACnB;MACE,UAAU;MACV,gBAAgB;MAChB,YAAY;MACZ,cAAc,EAAE;EACpB;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc,EAAE;IAChB;MACE,kBAAkB;MAClB,QAAQ,EAAE;;AAEhB,iDAAiD;AACjD;EACE;IACE,UAAU;IACV,aAAa,EAAE,EAAE;;AAErB,uEAAuE;AACvE,8CAA8C;AAC9C;EACE;IACE,UAAU,EAAE,EAAE;;AAElB,mDAAmD;AACnD;EACE;IACE,gBAAgB;IAChB,UAAU,EAAE,EAAE","sourcesContent":["html, body {\n  min-width: unset !important; }\n\n.App {\n  text-align: center; }\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 80px; }\n\n.App-header {\n  background-color: #222;\n  height: 150px;\n  padding: 20px;\n  color: white; }\n\n.App-title {\n  font-size: 1.5em; }\n\n.App-intro {\n  font-size: large; }\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n.loading-page {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  background-color: #4330ff; }\n\n.hide {\n  display: none; }\n\n.clear {\n  clear: both; }\n\n.helper-text:hover {\n  cursor: help; }\n\n.note-buttons {\n  float: right; }\n\n.save-note-button {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 120px !important;\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  margin-bottom: 0.5em;\n  border-width: 1px; }\n\n.cancel-note-link, .cancel-pw-button {\n  margin-right: 20px;\n  cursor: pointer;\n  color: #32c3b5 !important;\n  text-decoration: underline !important; }\n\n.error-color {\n  color: #ff2e2e; }\n\n.success-color {\n  color: #38bb15; }\n\n.margin-top-10 {\n  margin-top: 10px; }\n\n.react-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  height: 195px;\n  width: 300px;\n  border: 1px solid #ccc;\n  background: #fff;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 10px;\n  outline: none;\n  padding-top: 20px; }\n  .react-modal .modal-menu-title {\n    color: #c0c0c0;\n    width: 100%;\n    text-align: center;\n    font-size: 12px; }\n  .react-modal .modal-menu-item {\n    cursor: pointer;\n    color: #4330ff;\n    width: 100%;\n    text-align: center;\n    border: none;\n    background-color: white; }\n    .react-modal .modal-menu-item a {\n      text-decoration: none;\n      color: #2d7cbf !important; }\n  .react-modal .modal-menu-divider {\n    width: 100%;\n    border-top: 1px solid #eaeaea;\n    margin: 10px 0px 10px 0px;\n    padding: 0px; }\n  .react-modal.note-modal {\n    height: 160px; }\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal, .react-modal.closing-details {\n    padding: 45px; }\n    .react-modal.error-modal .close-modal, .react-modal.info-modal .close-modal, .react-modal.evaluation-modal .close-modal, .react-modal.closing-details .close-modal {\n      background-color: #fa504b;\n      border-color: #fa504b;\n      margin: auto;\n      display: block; }\n      .react-modal.error-modal .close-modal.btn-confirm, .react-modal.info-modal .close-modal.btn-confirm, .react-modal.evaluation-modal .close-modal.btn-confirm, .react-modal.closing-details .close-modal.btn-confirm {\n        color: #ffffff;\n        background-color: #606060;\n        border-color: #606060; }\n        .react-modal.error-modal .close-modal.btn-confirm:hover, .react-modal.info-modal .close-modal.btn-confirm:hover, .react-modal.evaluation-modal .close-modal.btn-confirm:hover, .react-modal.closing-details .close-modal.btn-confirm:hover {\n          background-color: #c0c0c0;\n          border-color: #c0c0c0; }\n      .react-modal.error-modal .close-modal:hover, .react-modal.info-modal .close-modal:hover, .react-modal.evaluation-modal .close-modal:hover, .react-modal.closing-details .close-modal:hover {\n        border-color: #fb736f;\n        background-color: #fb736f; }\n      .react-modal.error-modal .close-modal a, .react-modal.info-modal .close-modal a, .react-modal.evaluation-modal .close-modal a, .react-modal.closing-details .close-modal a {\n        color: #ffffff; }\n        .react-modal.error-modal .close-modal a:hover, .react-modal.info-modal .close-modal a:hover, .react-modal.evaluation-modal .close-modal a:hover, .react-modal.closing-details .close-modal a:hover {\n          text-decoration: none; }\n  .react-modal.evaluation-modal {\n    width: 40%;\n    height: fit-content;\n    padding: 35px 20px 20px; }\n\n.subheader {\n  padding: 5px;\n  padding-left: 10px;\n  color: #404040;\n  background: #dcdcdc;\n  font-size: 20px;\n  margin-top: 20px; }\n  .subheader.centered {\n    text-align: center; }\n\n.dim {\n  opacity: 0.6;\n  cursor: default; }\n\n.dim:hover {\n  background: transparent !important; }\n\n.center {\n  text-align: center; }\n\n.right {\n  text-align: right; }\n\n.blue-header {\n  color: #4330ff; }\n\n.bold {\n  font-weight: bold; }\n\n.red {\n  color: #fa504b !important; }\n\n.margin-bottom-10 {\n  margin-bottom: 10px; }\n\nbutton.standard {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 140px !important;\n  border-radius: 5px;\n  background-color: #4330ff;\n  border: 1px solid #c0c0c0;\n  color: #f2f2f2;\n  margin-bottom: 0.5em; }\n\nbutton.cancel {\n  cursor: pointer;\n  margin-top: 10px;\n  width: 140px !important;\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  margin-bottom: 0.5em; }\n  button.cancel:hover {\n    cursor: pointer; }\n  button.cancel:disabled {\n    cursor: not-allowed; }\n\nbutton.submit {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  margin: 0 20px 20px 20px;\n  height: 40px;\n  min-width: 120px;\n  width: calc(50% - 2px);\n  border-radius: 5px;\n  background: #4330ff;\n  color: white; }\n  button.submit:hover {\n    cursor: pointer; }\n  button.submit:disabled {\n    cursor: not-allowed; }\n\n.no-results-message {\n  text-align: center;\n  font-weight: bold;\n  margin-top: 30%; }\n\n.lb-highlight {\n  background-color: #ffebbb; }\n\n.splash-screen {\n  height: 100vh;\n  width: 100vw;\n  background-color: #4330ff;\n  -webkit-transition: visibility 1s, opacity 0.5s linear;\n  -ms-transition: visibility 1s, opacity 0.5s linear;\n  transition: visibility 1s, opacity 0.5s linear;\n  position: absolute;\n  visibility: visible;\n  opacity: 1;\n  top: 0; }\n  .splash-screen.loaded {\n    visibility: hidden;\n    opacity: 0; }\n  .splash-screen .splash-logo {\n    margin: 100px 0px; }\n    .splash-screen .splash-logo img {\n      width: 50%;\n      max-width: 950px;\n      margin: auto;\n      display: block; }\n  .splash-screen .spinner-container {\n    text-align: center;\n    color: #fff;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    font-size: 3em; }\n    .splash-screen .spinner-container .fa-spin {\n      position: relative;\n      top: 40%; }\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 585px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    width: 90%;\n    padding: 35px; } }\n\n/* Small devices (portrait tablets and large phones, 767px and under) */\n/* No greater than 767px, no less than 586px */\n@media only screen and (max-width: 767px) and (min-width: 586px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    width: 75%; } }\n\n/* Large devices (laptops/desktops, 768px and up) */\n@media only screen and (min-width: 768px) {\n  .react-modal.error-modal, .react-modal.info-modal, .react-modal.evaluation-modal {\n    max-width: 596px;\n    width: 90%; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
